export const areFloatsEqual = (a: number, b: number) =>
  Math.abs(a - b) <= Number.EPSILON;

export const radianToDegree = (radian: number): number => {
  'worklet';
  return radian * (180 / Math.PI);
};
export const degreeToRadian = (degree: number): number => {
  'worklet';
  return degree / (180 / Math.PI);
};

/**
 * Interpolate a value from a range to another range.
 * If either range is invalid, original value is returned.
 * The first number in the input range must be SMALLER than the second number.
 * @param {number} value - number to be interpolated
 * @param {[number, number]} inputRange - possible range of value
 * @param {[number, number]} outputRange - possible range of interpolated value
 * @returns the interpolated value or the original value
 */
export const interpolate = (
  value: number,
  inputRange: [number, number],
  outputRange: [number, number],
) => {
  'worklet';
  const [inputMin, inputMax] = inputRange;
  const [outputStart, outputEnd] = outputRange;

  if (inputMin >= inputMax) {
    return value;
  }

  const boundedValue = Math.max(Math.min(value, inputMax), inputMin);
  const normalizedValue = (boundedValue - inputMin) / (inputMax - inputMin);
  return outputStart + normalizedValue * (outputEnd - outputStart);
};

/**
 * Get a random num between min and max
 */
export const getRandomArbitrary = (a: number, b: number) => {
  const min = a > b ? b : a;
  const max = a > b ? a : b;
  const num = Math.random() * (max - min) + min;
  return num;
};

/**
 * Get a random point { x, y } in a circle with input radius
 */
export const getRandomPointInCircle = (
  radius: number,
  randomFunction = Math.random,
) => {
  'worklet'; // for reanimated to run in UI thread
  const angle = randomFunction() * Math.PI * 2;
  const x = Math.cos(angle) * radius;
  const y = Math.sin(angle) * radius;
  return { x, y };
};
